import * as React from 'react';

/**
 * A type of an object that have a route key as an object key
 * and a value whether to prevent that route.
 */

const PreventRemoveContext = /*#__PURE__*/React.createContext(undefined);
export default PreventRemoveContext;
//# sourceMappingURL=PreventRemoveContext.js.map